/* ==========================================================================
   Naqsha theme — interactions
   ========================================================================== */
(function () {
  'use strict';

  /* ---------- helpers ---------- */
  const $ = (sel, ctx) => (ctx || document).querySelector(sel);
  const $$ = (sel, ctx) => Array.from((ctx || document).querySelectorAll(sel));

  /* ---------- sticky header shadow ---------- */
  const header = $('.header');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- announcement bar rotation ---------- */
  const ann = $('[data-announcement]');
  if (ann) {
    const msgs = $$('[data-announcement-msg]', ann);
    if (msgs.length > 1) {
      let i = 0;
      msgs.forEach((m, idx) => { if (idx !== 0) m.hidden = true; });
      setInterval(() => {
        msgs[i].hidden = true;
        i = (i + 1) % msgs.length;
        msgs[i].hidden = false;
      }, 4000);
    }
  }

  /* ---------- mobile nav ---------- */
  const mobileNav = $('[data-mobile-nav]');
  if (mobileNav) {
    const open = () => { mobileNav.classList.add('is-open'); document.body.style.overflow = 'hidden'; };
    const close = () => { mobileNav.classList.remove('is-open'); document.body.style.overflow = ''; };
    $$('[data-mobile-open]').forEach(b => b.addEventListener('click', open));
    $$('[data-mobile-close]', mobileNav).forEach(b => b.addEventListener('click', close));
    $('.mobile-nav__overlay', mobileNav).addEventListener('click', close);
    document.addEventListener('keydown', e => { if (e.key === 'Escape') close(); });
  }

  /* ---------- cart drawer ---------- */
  const drawer = $('[data-cart-drawer]');
  if (drawer) {
    const open = () => { drawer.classList.add('is-open'); document.body.style.overflow = 'hidden'; };
    const close = () => { drawer.classList.remove('is-open'); document.body.style.overflow = ''; };
    window.cartDrawerOpen = open;
    $$('[data-cart-open]').forEach(b => b.addEventListener('click', e => { e.preventDefault(); open(); }));
    $$('[data-cart-close]', drawer).forEach(b => b.addEventListener('click', close));
    $('.cart-drawer__overlay', drawer).addEventListener('click', close);
    document.addEventListener('keydown', e => { if (e.key === 'Escape') close(); });
  }

  /* ---------- ajax add to cart ---------- */
  document.addEventListener('submit', async e => {
    const form = e.target;
    if (!form.matches('[data-ajax-cart], .product-form')) return;
    e.preventDefault();
    const btn = $('[data-add-button]', form) || $('button[type="submit"]', form);
    const orig = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = window.themeStrings ? window.themeStrings.adding : 'Adding…'; }
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(form),
        headers: { 'Accept': 'application/json' }
      });
      if (!res.ok) throw new Error('Add failed');
      const item = await res.json();
      await refreshCart();
      if (window.cartDrawerOpen) window.cartDrawerOpen();
      if (btn) { btn.textContent = window.themeStrings ? window.themeStrings.added : 'Added ✓'; }
      setTimeout(() => { if (btn) { btn.disabled = false; btn.textContent = orig; } }, 1600);
    } catch (err) {
      if (btn) { btn.disabled = false; btn.textContent = orig; }
      alert(window.themeStrings ? window.themeStrings.error : 'Something went wrong. Please try again.');
    }
  });

  async function refreshCart() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      const count = cart.item_count;
      $$('[data-cart-count]').forEach(el => {
        el.textContent = count;
        el.hidden = count === 0;
      });
      // update drawer contents
      const body = $('[data-cart-drawer-body]');
      const foot = $('[data-cart-drawer-foot]');
      if (body) {
        if (cart.items.length === 0) {
          body.innerHTML = '<p class="empty-state" style="padding:40px 0">' +
            (window.themeStrings ? window.themeStrings.emptyCart : 'Your cart is empty.') + '</p>';
          if (foot) foot.hidden = true;
        } else {
          body.innerHTML = cart.items.map(lineItemHTML).join('');
          if (foot) {
            foot.hidden = false;
            const sub = $('[data-cart-subtotal]', foot);
            if (sub) sub.textContent = formatMoney(cart.total_price);
          }
          bindDrawerQty(body);
        }
      }
    } catch (e) { /* silent */ }
  }

  function lineItemHTML(item) {
    const imgSrc = item.image ? item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=200' : '';
    const img = imgSrc ? '<img src="' + imgSrc + '" alt="' + esc(item.title) + '" loading="lazy">' : '';
    return '' +
      '<div class="cart-line" data-line="' + item.key + '">' +
        '<a class="cart-line__media" href="' + item.url + '">' + img + '</a>' +
        '<div>' +
          '<a class="cart-line__title" href="' + item.url + '">' + esc(item.product_title) + '</a>' +
          (item.variant_title && item.variant_title !== 'Default Title'
            ? '<div class="cart-line__variant">' + esc(item.variant_title) + '</div>' : '') +
          '<div class="cart-line__row">' +
            '<div class="quantity">' +
              '<button type="button" data-dqty="-1" aria-label="Decrease quantity">−</button>' +
              '<input type="number" value="' + item.quantity + '" min="0" data-dqty-input aria-label="Quantity">' +
              '<button type="button" data-dqty="1" aria-label="Increase quantity">+</button>' +
            '</div>' +
            '<span>' + formatMoney(item.final_line_price) + '</span>' +
          '</div>' +
          '<div style="margin-top:8px"><button type="button" class="cart-line__remove" data-remove>' +
            (window.themeStrings ? window.themeStrings.remove : 'Remove') + '</button></div>' +
        '</div>' +
      '</div>';
  }

  function bindDrawerQty(scope) {
    $$('.cart-line', scope).forEach(line => {
      const key = line.getAttribute('data-line');
      const input = $('[data-dqty-input]', line);
      $$('[data-dqty]', line).forEach(btn => {
        btn.addEventListener('click', () => {
          const delta = parseInt(btn.getAttribute('data-dqty'), 10);
          const next = Math.max(0, (parseInt(input.value, 10) || 0) + delta);
          changeLine(key, next);
        });
      });
      if (input) {
        input.addEventListener('change', () => changeLine(key, Math.max(0, parseInt(input.value, 10) || 0)));
      }
      const rm = $('[data-remove]', line);
      if (rm) rm.addEventListener('click', () => changeLine(key, 0));
    });
  }

  async function changeLine(key, qty) {
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      });
      await refreshCart();
    } catch (e) { /* silent */ }
  }

  function formatMoney(cents) {
    const fmt = window.themeStrings && window.themeStrings.moneyFormat;
    const amount = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    const amountComma = amount.replace('.', ',');
    const amountNoDec = Math.round(cents / 100).toString();
    if (fmt) {
      return fmt
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amountComma)
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, amountComma.replace(/,\d\d$/, ''))
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDec)
        .replace(/\{\{\s*amount\s*\}\}/g, amount);
    }
    return '€' + amountComma;
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  // initialise drawer lines if server-rendered
  const drawerBody = $('[data-cart-drawer-body]');
  if (drawerBody && $$('.cart-line', drawerBody).length) bindDrawerQty(drawerBody);

  /* ---------- product gallery ---------- */
  const gallery = $('[data-gallery]');
  if (gallery) {
    const mainWrap = $('[data-gallery-main]', gallery);
    const main = mainWrap ? $('img', mainWrap) : null;
    $$('[data-gallery-thumb]', gallery).forEach(thumb => {
      thumb.addEventListener('click', () => {
        const img = $('img', thumb);
        if (main && img) {
          main.src = img.src;
          main.srcset = img.srcset || '';
          main.alt = img.alt;
        }
        $$('[data-gallery-thumb]', gallery).forEach(t => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });
  }

  /* ---------- variant picker ---------- */
  const productForm = $('.product-form');
  if (productForm) {
    const variantInput = $('[name="id"]', productForm);
    const jsonEl = $('[data-variant-json]');
    const variants = jsonEl ? JSON.parse(jsonEl.textContent) : [];
    const priceEl = $('[data-product-price]');
    const compareEl = $('[data-product-compare]');
    const stockEl = $('[data-product-stock]');
    const addBtn = $('[data-add-button]', productForm);

    const pickers = $$('[data-option-index]', productForm);

    // Variant id → image map (built server-side)
    let imageMap = {};
    const imgEl = $('[data-variant-images]');
    if (imgEl) {
      try {
        const parsed = JSON.parse(imgEl.textContent);
        if (Array.isArray(parsed) && parsed.length === 2 && parsed[0] && parsed[1]) {
          const ids = String(parsed[0]).split('|');
          const srcs = String(parsed[1]).split('|');
          ids.forEach((id, i) => { if (srcs[i]) imageMap[id] = srcs[i]; });
        }
      } catch (e) { /* ignore */ }
    }

    const galleryWrap = $('[data-gallery-main]');
    const galleryMainImg = galleryWrap ? $('img', galleryWrap) : null;
    const stickyPrice = $('[data-sticky-price]');
    const stickyImg = $('[data-sticky-img]');

    function setGalleryImage(src) {
      if (!galleryMainImg || !src) return;
      if (galleryMainImg.src === src) return;
      galleryMainImg.src = src;
      galleryMainImg.removeAttribute('srcset');
      // highlight matching thumb, if any
      $$('[data-gallery-thumb]').forEach(t => {
        t.classList.toggle('is-active', t.getAttribute('data-full') === src);
      });
    }

    function selectedOptions() {
      return pickers.map(p => {
        const checked = $('input:checked', p);
        return checked ? checked.value : null;
      });
    }

    // variant.options may be absent in some outputs — fall back to option1..3
    function variantOptions(v) {
      if (Array.isArray(v.options)) return v.options.filter(o => o != null);
      return [v.option1, v.option2, v.option3].filter(o => o != null);
    }

    function findVariant(opts) {
      if (pickers.length === 0) return variants[0];
      return variants.find(v => {
        const vo = variantOptions(v);
        return vo.length === opts.length && vo.every((o, idx) => o === opts[idx]);
      });
    }

    function update() {
      const variant = findVariant(selectedOptions());
      if (!variant) {
        if (addBtn) { addBtn.disabled = true; }
        return;
      }
      if (variantInput) variantInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);
      // switch gallery to this variant's image
      const vImg = imageMap[String(variant.id)];
      if (vImg) {
        setGalleryImage(vImg);
        if (stickyImg) stickyImg.src = vImg;
      }
      // update swatch label text
      pickers.forEach(p => {
        if (!p.hasAttribute('data-swatch-option')) return;
        const label = $('[data-option-value]', p);
        const checked = $('input:checked', p);
        if (label && checked) label.textContent = checked.value;
      });
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
      if (stockEl) stockEl.classList.toggle('is-out', !variant.available);
      if (stockEl) {
        stockEl.textContent = variant.available
          ? (window.themeStrings ? window.themeStrings.inStock : 'In stock')
          : (window.themeStrings ? window.themeStrings.soldOut : 'Sold out');
      }
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available
          ? (window.themeStrings ? window.themeStrings.addToCart : 'Add to cart')
          : (window.themeStrings ? window.themeStrings.soldOut : 'Sold out');
      }
      // sync pickers (when navigating from URL)
      pickers.forEach((p, idx) => {
        const vo = variantOptions(variant);
        if (vo[idx]) {
          const inp = $$('input', p).find(i => i.value === vo[idx]);
          if (inp) inp.checked = true;
        }
      });
      // URL update (preserve other query params)
      if (history.replaceState) {
        try {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          history.replaceState(null, '', url.toString());
        } catch (e) { /* URL API unavailable */ }
      }
    }

    pickers.forEach(p => {
      $$('input', p).forEach(inp => inp.addEventListener('change', update));
    });
    update();
  }

  /* ---------- quantity steppers (page forms) ---------- */
  $$('[data-quantity]').forEach(q => {
    const input = $('input', q);
    $$('button', q).forEach(btn => {
      btn.addEventListener('click', () => {
        const delta = btn.getAttribute('data-step') === 'up' ? 1 : -1;
        const next = Math.max(1, (parseInt(input.value, 10) || 1) + delta);
        input.value = next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  /* ---------- accordions / FAQ ---------- */
  $$('[data-accordion-trigger]').forEach(trigger => {
    trigger.addEventListener('click', () => {
      const item = trigger.closest('.accordion__item');
      const list = item.parentElement;
      const isOpen = item.classList.contains('is-open');
      if (list.hasAttribute('data-accordion-single')) {
        $$('.accordion__item', list).forEach(i => i.classList.remove('is-open'));
      }
      item.classList.toggle('is-open', !isOpen);
      trigger.setAttribute('aria-expanded', String(!isOpen));
    });
  });

  /* ---------- sticky add-to-cart bar ---------- */
  const stickyAtc = $('[data-sticky-atc]');
  const buyWrap = $('[data-buy-button-wrap]');
  if (stickyAtc && buyWrap && 'IntersectionObserver' in window) {
    const stickyIo = new IntersectionObserver((entries) => {
      entries.forEach(en => {
        const show = !en.isIntersecting && en.boundingClientRect.top < 0;
        stickyAtc.classList.toggle('is-visible', show);
        stickyAtc.setAttribute('aria-hidden', String(!show));
      });
    }, { threshold: 0 });
    stickyIo.observe(buyWrap);

    const stickyBtn = $('[data-sticky-add]', stickyAtc);
    if (stickyBtn) {
      stickyBtn.addEventListener('click', () => {
        const form = $('.product-form');
        if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
      });
    }
  }

  /* ---------- collection sort ---------- */
  const sortSelect = $('[data-sort-by]');
  if (sortSelect) {
    sortSelect.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* ---------- hero background video ---------- */
  const heroVideo = $('[data-hero-video]');
  const videoToggle = $('[data-video-toggle]');
  if (heroVideo && videoToggle) {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const sync = () => {
      const playing = !heroVideo.paused && !heroVideo.ended;
      videoToggle.hidden = reduceMotion.matches;
      videoToggle.textContent = playing ? '❚❚' : '▶';
      videoToggle.setAttribute(
        'aria-label',
        playing ? videoToggle.dataset.labelPause : videoToggle.dataset.labelPlay
      );
    };
    videoToggle.addEventListener('click', () => {
      if (heroVideo.paused) {
        heroVideo.dataset.userPaused = '';
        heroVideo.play().catch(() => {});
      } else {
        heroVideo.dataset.userPaused = '1';
        heroVideo.pause();
      }
      sync();
    });
    ['play', 'pause', 'ended'].forEach(ev => heroVideo.addEventListener(ev, sync));
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        if (!heroVideo.paused) heroVideo.pause();
      } else if (!reduceMotion.matches && heroVideo.paused && heroVideo.dataset.userPaused !== '1') {
        heroVideo.play().catch(() => {});
      }
    });
    if (typeof reduceMotion.addEventListener === 'function') {
      reduceMotion.addEventListener('change', e => {
        if (e.matches) heroVideo.pause();
        sync();
      });
    }
    if (reduceMotion.matches) heroVideo.pause();
    videoToggle.hidden = false;
    sync();
  }

  /* ---------- reveal on scroll ---------- */
  const reveals = $$('.reveal');
  if (reveals.length && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(en => {
        if (en.isIntersecting) {
          en.target.classList.add('is-visible');
          io.unobserve(en.target);
        }
      });
    }, { threshold: 0.12 });
    reveals.forEach(el => io.observe(el));
  } else {
    reveals.forEach(el => el.classList.add('is-visible'));
  }

  /* ---------- initial cart count from server ---------- */
  (async function initCount() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      $$('[data-cart-count]').forEach(el => {
        el.textContent = cart.item_count;
        el.hidden = cart.item_count === 0;
      });
    } catch (e) { /* silent */ }
  })();
})();
